<div class="heading heading_standard heading_centered">Change password</div>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="oldPasswordFC"
      [validationErrors]="{
        required: 'Please, enter your current password',
      }"
    >
      <input
        [formControl]="oldPasswordFC"
        type="password"
        placeholder=""
        maxlength="30"
        autocomplete="Current password"
        id="email"
      />
      <label for="email">Current password</label>
      <ng-template [appErrorsHost] />
    </div>

    <app-new-password />

    <button
      type="submit"
      class="button button_dark button_standard button_centered"
    >
      Set new password
    </button>

    <p>
      Please enter a new password for your account. Once you set your new
      password, you can use it to log in to our website.
    </p>
  </div>
</form>
